import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAiScan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M3.295 3.295a2.714 2.714 0 0 1 1.92-.795h2.907a.776.776 0 0 1 0 1.551H5.214a1.163 1.163 0 0 0-1.163 1.163v2.908a.776.776 0 0 1-1.551 0V5.214c0-.72.286-1.41.795-1.919Zm11.807-.02c0-.428.347-.775.775-.775h2.909A2.715 2.715 0 0 1 21.5 5.214v2.908a.776.776 0 0 1-1.551 0V5.214a1.163 1.163 0 0 0-1.163-1.163h-2.909a.776.776 0 0 1-.775-.775ZM3.275 15.103c.429 0 .776.347.776.776v2.908a1.164 1.164 0 0 0 1.163 1.163h2.908a.776.776 0 1 1 0 1.551H5.214A2.714 2.714 0 0 1 2.5 18.786v-2.908c0-.429.347-.776.775-.776Zm17.45 0c.428 0 .775.347.775.776v2.908a2.714 2.714 0 0 1-2.714 2.714h-2.909a.775.775 0 1 1 0-1.551h2.909a1.163 1.163 0 0 0 1.163-1.163v-2.908c0-.429.347-.776.775-.776ZM18.4 12a.8.8 0 0 1 .8-.8h3a.8.8 0 0 1 0 1.6h-3a.8.8 0 0 1-.8-.8ZM4.8 12.8h-3a.8.8 0 0 1 0-1.6h3a.8.8 0 0 1 0 1.6Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M13.939 15.92v-1.19h1.034V9.27h-1.034V8.08H17.5v1.19h-1.045v5.46H17.5v1.19h-3.561ZM12.038 15.92l-.629-1.999H8.623l-.618 2H6.5L9.129 8.08h1.842l2.606 7.84h-1.539Zm-2-6.492h-.056l-1 3.224h2.068l-1.011-3.224Z"
    />
  </svg>
);
export default SvgTwoColorAiScan;
